import Route from "@ember/routing/route"

export default class IndexRoute extends Route {
  model(params: { invite_id: string }, transition) {
    // Occasionally users enter an invite URL that ends with a ")", causing the invite to fail.
    // Redirect to the URL without that ending char.
    const lastChar = params.invite_id[params.invite_id.length - 1]
    if ([")", ".", "!", "?"].includes(lastChar)) {
      this.transitionTo("invites.accept", params.invite_id.slice(0, -1))
    }
    return super.model(params, transition)
  }
}
